import React from "react";
import { motion } from "framer-motion";
import { useApp } from "@/AppContext";

export default function RadarScan() {
  const { t } = useApp();
  const steps = [t("scan_step1"), t("scan_step2"), t("scan_step3"), t("scan_step4")];
  return (
    <div className="flex flex-col items-center py-14" data-testid="ai-radar-scan">
      <div className="radar mb-8">
        <div className="radar-ring" />
        <div className="radar-ring inner" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-2.5 h-2.5 rounded-full bg-cyan-400 shadow-[0_0_16px_#00F0FF]" />
        </div>
      </div>
      <p className="font-head text-lg text-cyan-700 mb-6 text-center px-4">{t("ai_searching")}</p>
      <div className="space-y-3 w-full max-w-sm">
        {steps.map((s, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, x: -12 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: i * 0.5 }}
            className="flex items-center gap-3 text-sm font-mono-ps text-slate-600"
          >
            <span className="w-2 h-2 rounded-full bg-cyan-400 ps-pulse-dot" style={{ animationDelay: `${i * 0.2}s` }} />
            {s}
          </motion.div>
        ))}
      </div>
    </div>
  );
}
